// src/index.ts
var CONTROLLER_FILENAME_REGEX = /^(?:.*?(?:controllers|components)\/|\.?\.\/)?(.+)(?:[/_-]controller\..+?)$/;
function loadControllers(application, controllerModules, options = { nestedMode: false }) {
  const { nestedMode } = options;
  const definitions = definitionsFromGlob(controllerModules, nestedMode);
  application.load(definitions);
}
function definitionsFromGlob(controllerModules, nestedMode) {
  return Object.entries(controllerModules).map((entry) => definitionFromEntry(entry, nestedMode)).filter(Boolean);
}
function definitionFromEntry([name, controllerModule], nestedMode) {
  const identifier = identifierForGlobKey(name, nestedMode);
  const controllerConstructor = controllerModule.default;
  if (identifier && typeof controllerConstructor === "function")
    return { identifier, controllerConstructor };
}
function identifierForGlobKey(key, nestedMode) {
  const logicalName = (key.match(CONTROLLER_FILENAME_REGEX) || [])[1];
  if (!logicalName)
    return void 0;
  const fullName = logicalName.replace(/_/g, "-").replace(/\//g, "--");
  if (!nestedMode)
    return fullName;
  const nameParts = fullName.split("--");
  const lastPartIndex = nameParts.length - 1;
  if (nameParts.length >= 2 && nameParts[lastPartIndex] === nameParts[lastPartIndex - 1])
    nameParts.pop();
  return nameParts.join("--");
}
export {
  CONTROLLER_FILENAME_REGEX,
  definitionsFromGlob,
  identifierForGlobKey,
  loadControllers
};
